import { render, staticRenderFns } from "./damageSummary.pug?vue&type=template&id=32104f91&lang=pug&"
import script from "./damageSummary.js?vue&type=script&lang=js&"
export * from "./damageSummary.js?vue&type=script&lang=js&"
import style0 from "./damageSummary.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32104f91')) {
      api.createRecord('32104f91', component.options)
    } else {
      api.reload('32104f91', component.options)
    }
    module.hot.accept("./damageSummary.pug?vue&type=template&id=32104f91&lang=pug&", function () {
      api.rerender('32104f91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warrantyLayout/components/warrantySticky/components/damageSummary/index.vue"
export default component.exports